import { handleValidationChange } from "../CommonValidation";

export const validateOrder = ( items, setIsError ) => {
    

    var isValid = true;
    
    if (items.length !== 0) {
        items.map((data) => {
            if (
                data.product_id === "" ||
                data.product_id === undefined ||
                data.product_id === 0
            ) {
                handleValidationChange("product_id", true, setIsError);
                isValid = false;
            } else {
                handleValidationChange("product_id", false, setIsError);
            }
        });
    } else {
        handleValidationChange("itemlist", true, setIsError);
        isValid = false;
    }

    return isValid;
};
